<template>
    <div class="mb-1" v-if="filters">
        <div class="cursor-pointer py-1 font-bold filter-container" v-if="filters.length > 0" @click="clearAll()"><span
            class="text-white bg-gray-600 rounded-sm leading-none px-2">&times;</span><span
            class="cursor-pointer align-middle font-bold mx-1">Clear current search query, filters and sorts</span>
        </div>
        <div class="inline-block">{{
                filters.length == 0 ? 'No filter applied' : filters.length + ' Filter(s) applied:'
            }}
        </div>
        <div class="select-none inline-block bg-primary-100 rounded-t mx-2 border border-primary-200 text-primary-800"
             v-for="(filter, index) in filters" v-if="filter" @click="$emit('clear', filter)">
            <div class="inline-block border-primary-400 border-r px-2 font-bold cursor-pointer hover_text-primary-600">
                &times;
            </div>
            <div class="inline-block px-1">{{ filter.text }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        filters: Array
    },
    methods: {
        clearAll() {
            for (var f of this.filters) {
                this.$emit('clear', f)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-container {
    &:hover span:nth-child(1) {
        // @apply bg-pink-400;
        background-color: #429ed6;
    }

    &:hover span:nth-child(2) {
        // @apply text-pink-400;
        color: #429ed6;
    }
}
</style>